<template>
  <div>
    <label v-if="title" :for="`input-text-default${title}`">
      <span>
        {{ title }}
      </span>
      <span v-if="isRequired" style="color: #e2037e;">*</span>
    </label>
    <input
      :id="`input-text-default${title}`"
      :placeholder="placeholder"
      v-model="val"
      @keyup="emitChange"
      class="input"
      :class="{
        'gray-input': grayInput,
        'big-input-size': size === 'big',
      }"
      :type="type || 'text'"
      :min="min"
    />
    <div v-if="errorMsg" class="custom-error-wrapper">
      <span class="custom-error-msg">
        {{ errorMsg }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrimaryInput",
  emits: ["change"],
  props: [
    "placeholder",
    "value",
    "title",
    "grayInput",
    "isRequired",
    "size",
    "errorMsg",
    "type",
    "min",
  ],
  data() {
    return {
      val: this.value,
    };
  },
  watch: {
    value() {
      this.val = this.value;
    },
  },
  methods: {
    emitChange() {
      if (this.min !== undefined && this.val < this.min) {
        this.val = this.min;
      }
      this.$emit("change", this.val);
    },
  },
};
</script>
<style scoped>
.input {
  font-size: 16px;
  border-width: 1px;
  padding: 3px;
  border-radius: 5px;
  border-style: solid;
  border-color: #090741;
  max-width: 285px;
}
.input:focus {
  outline: none;
}
label {
  display: block;
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 12px;
}
.gray-input {
  border-color: #c1c1cf;
  height: 36px;
  min-width: 250px;
  padding-left: 5px;
}
.big-input-size {
  width: 100%;
  max-width: unset;
}
</style>
